module.exports = __webpack_public_path__ + "static/img/funny_22.7b271d81.jpg";